export default Object.freeze({
    pending: 'pending',
    fulfilled: 'fulfilled',
    rejected: 'rejected',
    cancelled: 'cancelled',
})
